import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const Close: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m8.007 9.061 5.117 5.117 1.06-1.06L9.068 8l5.116-5.117-1.06-1.06L8.007 6.94 2.871 1.804l-1.06 1.06 5.135 5.137-5.136 5.136 1.06 1.06 5.137-5.136Z"
      />
    </svg>
  );
};

export { Close };
